@if (hasPermissions && clickable) {
<mat-card
  appearance="outlined"
  class="widget__container"
  matRipple
  (dblclick)="onClickWidget()"
>
  @if (isLoading || !loggedUserInfo) {
  <mat-card-content>
    <app-bar-chart-skeleton></app-bar-chart-skeleton>
  </mat-card-content>
  } @if (isFailedToLoad && !isLoading && !loggedUserInfo) {
  <mat-card-content class="widget__content">
    <div class="load-error">
      <div class="error-content">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <div class="error-message">
          <div class="pl-1 error-text">
            <span class="failed-message-bold">{{
              'widgets.error.failed-to-load' | translate
            }}</span>
            <span class="failed-message">{{
              'widgets.error.refresh' | translate
            }}</span>
          </div>
        </div>
      </div>
      <button mat-icon-button (click)="refreshWidget()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-card-content>
  } @if (!isFailedToLoad) {
  <div class="widget__details">
    <div class="widget__description">
      <span class="title">{{ widget?.title | translate }}</span>
      <span class="subtitle">{{
        widget?.category_description | translate
      }}</span>
      <span class="subtitle">{{ description }}</span>
    </div>
    <button mat-icon-button (click)="refreshWidget()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  } @if (!isFailedToLoad && loggedUserInfo) {
  <mat-card-content class="widget__content">
    <ngx-charts-bar-vertical
      [results]="single"
      [xAxis]="xAxis"
      [legend]="showLegends"
      [yAxis]="yAxis"
      [scheme]="scheme"
    >
    </ngx-charts-bar-vertical>
  </mat-card-content>
  }
</mat-card>
} @if (hasPermissions && !clickable) {
<mat-card appearance="outlined" class="widget__container">
  @if (isLoading) {
  <mat-card-content>
    <app-bar-chart-skeleton></app-bar-chart-skeleton>
  </mat-card-content>
  } @if (isFailedToLoad && !isLoading) {
  <mat-card-content class="widget__content">
    <div class="load-error">
      <div class="error-content">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <div class="error-message">
          <div class="pl-1 error-text">
            <span class="failed-message-bold">{{
              'widgets.error.failed-to-load' | translate
            }}</span>
            <span class="failed-message">{{
              'widgets.error.refresh' | translate
            }}</span>
          </div>
        </div>
      </div>
      <button mat-icon-button (click)="refreshWidget()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-card-content>
  } @if (!isFailedToLoad && !isLoading) {
  <div class="widget__details">
    <div class="widget__description">
      <span class="title">{{ widget?.title | translate }}</span>
      <span class="subtitle">{{
        widget?.category_description | translate
      }}</span>
      <span class="subtitle">{{ description }}</span>
    </div>
    <button mat-icon-button (click)="refreshWidget()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  } @if (!isFailedToLoad && !isLoading) {
  <mat-card-content class="widget__content">
    <ngx-charts-bar-vertical
      [class.dark-mode-x]="darkMode"
      [class.dark-mode-y]="darkMode"
      [results]="single"
      [xAxis]="xAxis"
      [legend]="showLegends"
      [yAxis]="yAxis"
      [scheme]="scheme"
    >
    </ngx-charts-bar-vertical>
  </mat-card-content>
  }
</mat-card>
}
